import MonegraphERC721JSON from './MonegraphERC1155V2.json';

const contract = require('@truffle/contract');

export default contract({
  abi: MonegraphERC721JSON.abi,
});
